import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const PlayRectangle = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <path
        d="M12.6667 13H3.33333C2.6 13 2 12.4 2 11.6667V4.33333C2 3.59667 2.59667 3 3.33333 3H12.6667C13.4 3 14 3.6 14 4.33333V11.6667C14 12.4033 13.4033 13 12.6667 13Z"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.338 6.06615L9.76401 7.50082C10.0707 7.68215 10.0707 8.12615 9.76401 8.30749L7.338 9.74215C7.02534 9.92682 6.63 9.70149 6.63 9.33882V6.46949C6.63067 6.10682 7.026 5.88149 7.338 6.06615V6.06615Z"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

PlayRectangle.propTypes = {
  color: PropTypes.string
};

PlayRectangle.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default PlayRectangle;
